module.exports = __webpack_public_path__ + "b6fddcc8.svg";